<template>
  <div class="ai-assistant-button">
    <v-tooltip location="top" open-delay="500">
      <template v-slot:activator="{ props }">
        <v-btn
          v-bind="props"
          variant="tonal"
          icon="mdi-creation"
          :active="sidePanelTab === 'chatLog' && showSidePanel"
          @click="openAiAssistant"
        />
      </template>
      <span>AI Assistant (BETA)</span>
    </v-tooltip>
  </div>
</template>

<script setup>
import { useStore } from 'vuex'
import { computed } from 'vue'

const store = useStore()

const sidePanelTab = computed(() => store.state.sidePanelTab)
const showSidePanel = computed(() => store.state.showSidePanel)

const openAiAssistant = () => {
  store.commit('setSidePanelTab', 'chatLog')
  store.commit('showSidePanel', true)
}

</script>

<style scoped>
.ai-assistant-button {
  display: flex;
  padding: 4px;
  border-radius: 8px;
  background-color: var(--light-1);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
}

:deep(.ai-assistant-button) {
  .mdi-creation {
    --v-icon-size-multiplier: 1.1;
  }
}

@keyframes pulse-glow {
  to {
    box-shadow: 0 0 0 8px #73e5a601;
  }
}
</style>
